/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_TitleInputs */



/**
* | output |
* | --- |
* | "Iconik Proxy Import" |
*
* @param {Iconik_Proxy_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_title = /** @type {((inputs?: Iconik_Proxy_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Import du proxy Iconik")
	if (locale === "de") return /** @type {LocalizedString} */ ("Iconik Proxy Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione proxy Iconik")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Iconik Proxy Import")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de proxy de Iconik")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Iconik代理导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Iconik プロキシインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आइकॉनिक प्रॉक्सी आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de proxy Iconik")
	return /** @type {LocalizedString} */ ("Iconik Proxy Import")
});